<template>
    <b-modal size="xl" button-size="sm" :title="'Devolução > Tarefa > ' + this.title"
        v-model="showTarefaAprovacaoAlmoxarifadoModal" @hidden="cancelar">
        <b-card bg-variant="light">
            <div>
                <span style="font-size: 16px">
                    <strong>Devolução:</strong> {{ devolucao.id }}<br />
                    <strong>Solicitante:</strong>
                    {{ devolucao.departamento.descricao }}<br />
                    <strong>Data:</strong> {{ formatarData(tarefa.dataAtual) }}
                </span> <br />
                <span style="font-size: 16px">
                    <strong>Tarefa:</strong> {{ tarefa.tipoTarefaDevolucao.descricao
                    }}<br />
                    <strong>Status:</strong> {{ tarefa.status.descricao }}<br />
                </span>
            </div>

            <b-table id="t-tarefa-item" responsive class="mt-3" small :items="itens" :fields="fieldsTabelaItens"
                :busy="this.busy">
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>

                <template #cell(quantidadeAceita)="data">
                    <lg-number v-model="data.item.quantidadeAceita" required :precision="{ min: 0, max: 0 }"
                        :disabled="isVisualizacao" />
                </template>
            </b-table>

            <b-col lg="12" sm="12" class="text-left">
                <b-form-group label-for="textarea-formatter" class="col-12">
                    <label for="textarea-auto-height">Observação:</label>
                    <b-form-textarea :disabled="isVisualizacao" v-model="form.obs">
                    </b-form-textarea>
                </b-form-group>
            </b-col>
        </b-card>

        <template #modal-footer>
            <div class="d-flex w-100 justify-content-center">
                <b-button id="salvar" variant="success" size="sm" pill class="ml-2" @click="salvar(false)"
                    v-if="!isVisualizacao">
                    <b-tooltip target="salvar" title="Salvar"></b-tooltip>
                    <div class="btn-size-alinhamento">
                        <b-icon icon="check2-circle" scale="1.5" />
                    </div>
                </b-button>
                <b-button id="concluir" variant="primary" size="sm" pill class="ml-2" @click="concluir"
                    v-if="!isVisualizacao">
                    <b-tooltip target="concluir" title="Proxima Tarefa"></b-tooltip>
                    <b-icon icon="arrow-right" />
                </b-button>
                <b-button id="cancelar" variant="danger" size="sm" pill class="ml-2" @click="cancelar">
                    <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>
                    <div class="btn-size-alinhamento">
                        <b-icon icon="x-circle" />
                    </div>
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgNumber from "@/core/components/Inputs/LgNumber.vue"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"

export default {
    components: { LgNumber },
    mixins: [ListResourceMixin, FormResourceMixin],

    data() {
        return {
            showTarefaAprovacaoAlmoxarifadoModal: true,
            itens: [],
            form: {
                obs: "",
            },
        }
    },

    props: {
        id: String,
        tarefa: Object,
        uri: String,
        propQuantidade: String,
        isVisualizacao: {
            type: Boolean,
            default: false,
        },
        devolucao: {
            type: Object,
            required: true,
        },
    },

    async beforeMount() {
        this.$devolucaoTarefa = new ResourceService(
            `/api/devolucoes/${this.devolucao.id}/tarefas`
        )

        this.$tarefaService = new ResourceService("/api/tarefadevolucao")
    },

    mounted() {
        this.tarefaItens()
    },

    computed: {
        fieldsTabelaItens() {
            return [
                {
                    key: "itemDevolucao.almoxarifadoProduto.produto.numero",
                    label: "NÚMERO",
                    thStyle: "font-size: 16px; font-weight: 600; width: 20%",
                    tdStyle: "font-size: 13px; width: 20%",
                    tdClass: "py-0 ",
                },
                {
                    key: "itemDevolucao.almoxarifadoProduto.produto.descricaoResumida",
                    label: "PRODUTO",
                    thStyle: "font-size: 16px; font-weight: 600; width: 50%",
                    tdStyle: "font-size: 13px; width: 50%",
                    tdClass: "py-0 ",
                },
                {
                    key: "quantidadeDevolvida",
                    label: "DEVOLVIDO",
                    thStyle: "font-size: 16px; font-weight: 600; width: 10%",
                    tdStyle: "font-size: 13px; width: 10%",
                    tdClass: "py-0 ",
                    formatter: value => value || "-",
                },
                {
                    key: "quantidadeAceita",
                    label: "APROVADO",
                    thStyle: "font-size: 16px; font-weight: 600; width: 10%",
                    tdStyle: "font-size: 13px; width: 10%",
                    tdClass: "py-0 ",
                    formatter: value => value || "-",
                },
            ]
        },

        title() {
            return this.tarefa ? this.tarefa.tipoTarefaDevolucao.descricao : ""
        },
    },

    methods: {
        async salvar(concluir) {
            if (
                this.itens.find(
                    item => !item.quantidadeAceita || item.quantidadeAceita <= 0
                )
            ) {
                this.$notify({
                    message: "Digite a quantidade de todos os itens",
                    type: "danger",
                })
                return
            }

            if (
                this.itens.find(
                    item => item.quantidadeAceita > item.quantidadeDevolvida
                )
            ) {
                this.$notify({
                    message:
                        "A quantidade aceita não pode ser maior do que a quantidade devolvida",
                    type: "danger",
                })
                return
            }

            const itens = this.itens.map(({ itemDevolucao, quantidadeAceita }) => ({
                itemDevolucaoId: itemDevolucao.id,
                [this.propQuantidade]: quantidadeAceita,
            }))

            this.busy = true

            try {
                await this.$devolucaoTarefa
                    .put(`${this.tarefa.id}${this.uri}`, {
                        itensDevolucao: itens,
                        observacao: this.form.obs,
                    });
                this.busy = false
                if (concluir) {
                    this.concluirTarefa()
                } else {
                    this.$emit("tarefaAlmoxarifadoFinalizado", {})

                    this.cancelar()

                    this.$notify({
                        title: "Sucesso",
                        message: "Tarefa salva com sucesso",
                        type: "success",
                    })
                }

            } catch (e) {
                this.busy = false
                this.$notify({
                    message: e.response.data,
                    type: "danger",
                })

            }
        },

        formatarData(valor) {
            if (!valor) return ""
            const data = new Date(valor)
            const dia = data.getDate().toString().padStart(2, "0")
            const mes = (data.getMonth() + 1).toString().padStart(2, "0")
            const ano = data.getFullYear()
            const hora = data.getHours().toString().padStart(2, "0")
            const minutos = data.getMinutes().toString().padStart(2, "0")
            const segundos = data.getSeconds().toString().padStart(2, "0")
            return `${dia}/${mes}/${ano} ${hora}:${minutos}:${segundos}`
        },

        async concluir() {
            this.salvar(true)
        },

        async concluirTarefa() {
            if (
                this.itens.find(
                    item => !item.quantidadeAceita || item.quantidadeAceita <= 0
                )
            ) {
                this.$notify({
                    message: "Digite a quantidade de todos os itens",
                    type: "danger",
                })
                return
            }

            const itens = this.itens.map(({ itemDevolucao, quantidadeAceita }) => ({
                itemDevolucaoId: itemDevolucao.id,
                [this.propQuantidade]: quantidadeAceita,
            }))

            try {

                this.busy = true
                await this.$devolucaoTarefa
                    .put(`${this.tarefa.id}${this.uri}/finalizar`, {
                        itensDevolucao: itens,
                        observacao: this.form.obs,
                    });
                this.busy = false
                this.$emit("tarefaAlmoxarifadoFinalizado", {})
                this.cancelar();
                this.$notify({
                    title: "Sucesso",
                    message: "Tarefa finalizada com sucesso",
                    type: "success",
                })
            } catch (e) {
                this.busy = false
                this.$notify({
                    message: e.response.data,
                    type: "danger",
                })
            }
        },
        async tarefaItens() {
            this.busy = true

            await this.$tarefaService.findById(this.tarefa.id).then(response => {
                this.busy = false
                this.form.obs = response.data.obs
                this.itens = response.data.itensDevolucao
            })
        },

        cancelar() {
            this.showTarefaAprovacaoAlmoxarifadoModal = false
            this.$emit("close")
        },
    },
}
</script>
<style lang="scss">
.modal-footer,
.modal-body {
    padding: 0.25rem !important;
}

table {
    .form-control {
        padding: 3px 9px;
        height: 30px;
        text-align: right;
    }
}
</style>
